/*
  Global ordering gate. Reads the ordering switch from the live endpoint and,
  when it's OFF, hides every order button on the site and shows a paused note.
  The endpoint URL is written into a data attribute by any section that
  includes the order links while GPS is configured.
*/
(function () {
  'use strict';
  var host = document.querySelector('[data-wb-order-endpoint]');
  if (!host) { return; }
  var endpoint = host.getAttribute('data-wb-order-endpoint');
  if (!endpoint || !window.fetch) { return; }

  fetch(endpoint, { method: 'GET' })
    .then(function (r) { return r.json(); })
    .then(function (state) {
      if (!state || state.ordering !== 'off') { return; }
      // Hide every order link/button site-wide
      var sel = '.wb-bar__btn--order, .wb-ord__btns, .wb-menu__ordercta, .wb-actionbar__item--order';
      var nodes = document.querySelectorAll(sel);
      for (var i = 0; i < nodes.length; i++) { nodes[i].style.display = 'none'; }
      // Order page: swap the status line to a paused message
      var textEl = document.querySelector('[data-wb-order-text]');
      var statusEl = document.querySelector('[data-wb-order-status]');
      if (textEl) { textEl.textContent = 'Online ordering is paused right now \u2014 catch us at the window'; }
      if (statusEl) { statusEl.classList.remove('is-live'); }
    })
    .catch(function () {});
})();
